import React from "react";
import { MessageCircle } from "lucide-react";
import { TESTIDS, waUrl } from "@/lib/brand";

export const FloatingWhatsApp = () => (
  <a
    href={waUrl()}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={TESTIDS.floatingWhatsapp}
    className="fixed bottom-24 lg:bottom-6 right-4 sm:right-6 z-40 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] shadow-2xl shadow-[#25D366]/40 flex items-center justify-center hover:scale-110 transition-transform"
    aria-label="Chat on WhatsApp"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30"></span>
    <MessageCircle className="w-7 h-7 sm:w-8 sm:h-8 text-white relative" strokeWidth={2} />
  </a>
);
